<template>
  <div
    v-show="show"
    class="bg-gradient-to-r from-primary-40 to-primary-140 py-20 text-center w-100 overflow-x-auto relative"
  >
    <div class="absolute top-4 right-4 cursor-default">
      <slot name="closeButton" />
    </div>
    <div class="mt-5 grid grid-flow-rows auto-rows-fr grid-cols-1 mx-auto max-w-screen-xl md:grid md:grid-flow-col md:justify-items-center md:auto-cols-fr gap-4 md:gap-0">
      <subcards-online-access
        v-if="subscriptions.subonline"
        class="order-3 md:order-3 md:max-w-sm w-full px-4 md:p-1"
        :included-in-sub="subscriptions.subonline"
        :large="false"
        :short-card="false"
      >
        <template #button>
          <div>
            <button
              class="font-bold rounded-none rounded bg-summit-green py-2 text-white px-8 py-2"
              @click="subscribeNow('SUBONLINE')"
            >
              Subscribe Now <t-icon
                name="chevron-right"
                class="ml-2"
              />
            </button>
          </div>
        </template>
      </subcards-online-access>
      <subcards-virtual-access
        v-if="subscriptions.subvirtual"
        class="order-2 md:order-4 md:max-w-sm w-full px-4 md:p-1"
        :included-in-sub="subscriptions.subvirtual"
        :large="false"
        :short-card="false"
      >
        <template #button>
          <div>
            <button
              class="font-bold rounded-none rounded bg-summit-green py-2 text-white px-8 py-2"
              @click="subscribeNow('SUBVIRTUAL')"
            >
              Subscribe Now <t-icon
                name="chevron-right"
                class="ml-2"
              />
            </button>
          </div>
        </template>
      </subcards-virtual-access>
      <subcards-all-access
        v-if="subscriptions.suballaccess"
        class="order-1 md:order-5 md:max-w-sm w-full px-4 md:p-1"
        :included-in-sub="subscriptions.suballaccess"
        :large="false"
        :short-card="false"
      >
        <template #button>
          <button
            class="font-bold rounded-none rounded bg-summit-green text-white px-8 py-2"
            @click="subscribeNow('SUBALLACCESS')"
          >
            Subscribe Now <t-icon
              name="chevron-right"
              class="ml-2"
            />
          </button>
        </template>
      </subcards-all-access>
    </div>
    <div class="hidden grid grid-cols-1 mx-auto max-w-screen-xl md:grid md:grid-flow-col md:auto-cols-fr justify-items-center gap-4">
      <div
        v-if="subscriptions.subonline"
        class="max-w-sm"
      >
        <p class="font-bold text-sm text-accent-light mt-4">
          This course is included <t-icon
            name="check"
            class="text-accent-light"
          />
        </p>
        <p class="text-white text-sm">
          with an Online Access Subscription
        </p>
      </div>
      <div
        v-if="subscriptions.subvirtual"
        class="max-w-sm"
      >
        <p class="font-bold text-sm text-accent-light mt-4">
          This course is included <t-icon
            name="check"
            class="text-accent-light"
          />
        </p>
        <p class="text-white text-sm">
          with an Virtual Subscription
        </p>
      </div>
      <div
        v-if="subscriptions.suballaccess"
        class="max-w-sm"
      >
        <p class="font-bold text-sm text-accent-light mt-4">
          This course is included <t-icon
            name="check"
            class="text-accent-light"
          />
        </p>
        <p class="text-white text-sm">
          with an All Access Subscription
        </p>
      </div>
    </div>
    <div
      v-if="courseTest"
      id="hep-sub-card"
      class="bg-black bg-opacity-50 rounded lg:w-full p-6 mt-6 max-w-screen-lg mx-auto"
    >
      <div class="md:flex items-center justify-center">
        <img
          src="//summitproedu.imgix.net/redesign-assets/pages/course/icon-single-course.svg"
          alt="HEP Single Course"
          class="h-8 mx-auto md:mx-0 md:mr-3"
        />
        <h6 class="text-lg text-white font-bold">
          Single Course Purchase - Only ${{ selectedSession.price }} -
        </h6>
        <course-non-subscriber-payment-btn
          :is-valid-subscription="isValidSubscription"
          :selected-session="selectedSession"
          :loading="loading"
          :redirect-loading="redirectLoading"
          :selected-format="selectedFormat"
          :loading-item="loadingItem"
          :is-brochure="isBrochure"
          :btn-state="btnState"
          :is-included-in-subscription="isIncludedInSubscription"
          :is-two-hours-before-start-time="isTwoHoursBeforeStartTime"
          :check-item-selected="checkItemSelected"
          @add-to-subscription="addToSubscription()"
          @proceed-to-checkout="proceedToCheckout()"
          @add-item-to-cart="addItemToCart()"
          @add-cart-item="addCartItem()"
          @go-to-live="goToLive()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, } from 'pinia';
import { useCartStore, } from '../../stores/cart';

export default {
  name: 'AsideTransition',
  props: {
    subscriptions: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    selectedFormat: {
      type: String,
      required: true,
    },
    selectedSession: {
      type: Object,
      required: true,
    },
    isValidSubscription: {
      type: Boolean,
      default: false,

    },
    checkItemSelected: {
      type: Boolean,
      default: false,

    },
    isIncludedInSubscription: {
      type: Boolean,
      default: false,

    },
    isTwoHoursBeforeStartTime: {
      type: Boolean,
      default: false,

    },
    loading: {
      type: Boolean,
      default: false,

    },
    redirectLoading: {
      type: Boolean,
      default: false,

    },
    loadingItem: {
      type: Boolean,
      default: false,

    },
    isBrochure: {
      type: Boolean,
      default: false,

    },
    btnState: {
      type: String,
      default: '',
    },
    courseTest: {
      type: Boolean,
      default: false,

    },
  },
  methods: {
    ...mapActions(useCartStore, ['addItem']),
    async subscribeNow(subscriptionId) {
      console.log('SUBSCRIBENOW: ' + JSON.stringify(subscriptionId));
      await this.addCartItem({ id: subscriptionId });
      this.$emit('subscribe-now', subscriptionId);
    },
    getParts(partPrefix) {
      const keys = Object.keys(this.subscriptions)
        .filter(key => key.startsWith(partPrefix));
      const values = [];
      keys.forEach(k => values.push(this.subscriptions[k]));
      return values;
    },
    proceedToCheckout() {
      this.$emit('proceed-to-checkout');
    },
    addItemToCart() {
      this.$emit('add-item-to-cart');
    },
    addCartItem() {
      this.$emit('add-cart-item');
    },
    goToLive() {
      this.$emit('go-to-live');
    },
  },
};
</script>
